/*
 * Back in stock ("Notify me") drawer – snippets/notify-me-modal.liquid
 * Subscribes the email to the selected variant via the Klaviyo Client API.
 * Docs: https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription
 */
(function () {
  var modal = document.querySelector('[data-notify-me]');
  if (!modal) return;

  var KLAVIYO_REVISION = '2026-10-15';
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var companyId = modal.dataset.companyId;
  var listId = modal.dataset.listId;
  var language = modal.dataset.language || 'en';
  var form = modal.querySelector('[data-notify-me-form]');
  var emailInput = modal.querySelector('[data-notify-me-email]');
  var errorEl = modal.querySelector('[data-notify-me-error]');
  var newsletterInput = modal.querySelector('[data-notify-me-newsletter]');
  var submitBtn = modal.querySelector('[data-notify-me-submit]');
  var footer = modal.querySelector('[data-notify-me-footer]');
  var successEl = modal.querySelector('[data-notify-me-success]');
  var productEl = modal.querySelector('[data-notify-me-product]');
  var sizeEl = modal.querySelector('[data-notify-me-size]');

  var currentVariantId = null;
  var lastFocused = null;

  function isValidEmail(value) {
    return EMAIL_PATTERN.test(value.trim());
  }

  function showError(message) {
    errorEl.textContent = message || '';
    emailInput.setAttribute('aria-invalid', message ? 'true' : 'false');
  }

  function setLoading(loading) {
    submitBtn.classList.toggle('is-loading', loading);
    submitBtn.disabled = loading || !isValidEmail(emailInput.value);
  }

  function reset() {
    form.hidden = false;
    footer.hidden = false;
    successEl.hidden = true;
    showError('');
    setLoading(false);
  }

  function open(options) {
    options = options || {};
    currentVariantId = options.variantId;
    productEl.textContent = options.productTitle || '';
    sizeEl.textContent = options.size ? modal.dataset.sizeLabel + ': ' + options.size : '';
    reset();

    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('notify-me-open');
    setTimeout(function () { emailInput.focus(); }, 50);
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('notify-me-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function klaviyoPost(endpoint, payload) {
    return fetch('https://a.klaviyo.com/client/' + endpoint + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo ' + endpoint + ' responded with ' + response.status);
    });
  }

  function subscribeBackInStock(email) {
    return klaviyoPost('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + currentVariantId } }
        }
      }
    });
  }

  // Stores the storefront language on the profile, so the flow can split BG / EN emails.
  function saveLanguage(email) {
    return klaviyoPost('profiles', {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          properties: { notify_me_language: language }
        }
      }
    });
  }

  function subscribeNewsletter(email) {
    return klaviyoPost('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Notify me (PDP)',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }

  emailInput.addEventListener('input', function () {
    submitBtn.disabled = !isValidEmail(emailInput.value);
    if (errorEl.textContent) showError('');
  });

  emailInput.addEventListener('blur', function () {
    if (emailInput.value && !isValidEmail(emailInput.value)) showError(modal.dataset.errorEmail);
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var email = emailInput.value.trim();

    if (!isValidEmail(email)) {
      showError(modal.dataset.errorEmail);
      emailInput.focus();
      return;
    }
    if (!companyId || !currentVariantId) {
      console.warn('[Notify me] Missing Klaviyo public key (theme settings) or variant id.');
      showError(modal.dataset.errorGeneric);
      return;
    }

    setLoading(true);
    // The language must be on the profile before Klaviyo picks the BG / EN branch of the flow.
    saveLanguage(email)
      .catch(function (error) { console.warn('[Notify me]', error); })
      .then(function () {
        return subscribeBackInStock(email);
      })
      .then(function () {
        // The newsletter opt-in is a bonus – a failure here must not hide the back in stock success.
        if (newsletterInput && newsletterInput.checked && listId) {
          return subscribeNewsletter(email).catch(function (error) { console.warn('[Notify me]', error); });
        }
      })
      .then(function () {
        form.reset();
        form.hidden = true;
        footer.hidden = true;
        successEl.hidden = false;
        successEl.focus();
      })
      .catch(function (error) {
        console.warn('[Notify me]', error);
        showError(modal.dataset.errorGeneric);
      })
      .then(function () {
        setLoading(false);
      });
  });

  modal.addEventListener('click', function (event) {
    if (event.target.closest('[data-notify-me-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) close();
  });

  window.HursaNotifyMe = { open: open, close: close };
})();
